module.exports = __webpack_public_path__ + "static/media/05.9d4cba1e.jpg";